import { useState, useCallback } from 'react';

export const useCurrencyForm = () => {
    const [serverMessage, setServerMessage] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const submitCurrencyForm = useCallback(async (isoCode) => {
        // Ensure selector is correct selector for form 
        const form = document.querySelector('#currency-form');

        window.Shopify.captcha.protect(form, () => {
            
            // Ensure that isocode is passed through to function from enabledCountries[0].isoCode
            form.elements['country_code'].value = `${isoCode}`;
            form.elements['utf8'].value = '✓';
            form.elements['form_type'].value = 'localization';
            form.elements['_method'].value = 'put';
            form.elements['return_to'].value = '/';
            form.submit();
        });
            
        setIsSubmitting(true);
    }, []);

    return {
        serverMessage,
        isSubmitting,
        submitCurrencyForm,
    };
};

export default useCurrencyForm;
